export default function ButtonFunction({ 
    func = () => console.log("Click!"),
    title = "button title",
    primary = true,
    disabled = false,
    type = "button"
}) {
  return (
    <button
      type={type}
      onClick={func}
      disabled={disabled}
      className={`w-1/2 py-2 rounded-lg ${disabled ? " bg-gray-400" : primary ? "bg-green-600 text-white font-medium hover:bg-green-700 " : "border border-gray-600 text-gray-300 hover:border-green-400"}`}
    >
      {title}
    </button>
  );
}